export async function occupyAndConfirm(platform, occupyRequest) {
    const occupancy = await platform.occupy(occupyRequest);
    await platform.confirmOccupancy(occupancy.uuid);
    return occupancy;
}
//# sourceMappingURL=occupyAndConfirm.js.map